import React from 'react';
import { DropdownMenu } from "../DropdownMenu";
import { FullPageModalFooterCenter } from "../FullPageModal";
import { TextButton } from "../TextButton";
import { Typography } from "../Typography";
import styles from "./FullPageModalAdditionalActions.module.scss";
export function FullPageModalAdditionalActions(props) {
  const {
    inlineActions,
    dropdownActions
  } = props;
  const hasDropdownActions = dropdownActions.length > 0;
  return /*#__PURE__*/React.createElement(FullPageModalFooterCenter, null, /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, inlineActions.map((action, idx) => {
    const {
      text,
      testid,
      disabled,
      skin,
      intent,
      tooltipTitle,
      onClick
    } = action;
    const tooltip = tooltipTitle ? {
      title: tooltipTitle
    } : undefined;
    const isLast = idx === inlineActions.length - 1;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: text
    }, /*#__PURE__*/React.createElement(TextButton, {
      underline: "none",
      skin: skin || 'secondary',
      intent: intent,
      disabled: disabled,
      "data-testid": testid,
      tooltip: tooltip,
      onClick: onClick
    }, text), (!isLast || hasDropdownActions) && /*#__PURE__*/React.createElement(Typography, {
      className: styles.sep
    }, "|"));
  }), hasDropdownActions && /*#__PURE__*/React.createElement(DropdownMenu, {
    vAlign: "top",
    target: /*#__PURE__*/React.createElement(TextButton, {
      skin: "secondary",
      underline: "none",
      "data-testid": "additional-dropdown-actions"
    }, "More")
  }, dropdownActions.map(action => {
    const {
      text,
      testid,
      disabled,
      skin,
      intent,
      iconStart,
      onClick,
      tooltipTitle
    } = action;
    const tooltip = tooltipTitle ? {
      title: /*#__PURE__*/React.createElement("div", {
        "data-testid": testid && "".concat(testid, "-tooltip")
      }, tooltipTitle)
    } : undefined;
    return /*#__PURE__*/React.createElement(DropdownMenu.Item, {
      key: text,
      skin: skin,
      intent: intent,
      disabled: disabled,
      "data-testid": testid,
      iconStart: /*#__PURE__*/React.createElement("div", {
        className: styles.actionIcon
      }, iconStart),
      onClick: onClick,
      tooltipProps: tooltip
    }, text);
  }))));
}